var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.createVisible,
            title: "Chuyển đổi điểm danh và nhận xét V4",
            size: "lg",
            top: "5vh",
            "append-to-body": "",
            "close-on-click-modal": false,
            "use-panel": false,
            "before-close": _vm.handleBeforeCloseCreate,
            "dialog-class": "school-migration-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "sk-dialog__footer" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-cancel",
                          attrs: { plain: "", disabled: _vm.submitting },
                          on: {
                            click: function ($event) {
                              _vm.createVisible = false
                            },
                          },
                        },
                        [_vm._v("\n          Đóng\n        ")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-save",
                          attrs: {
                            type: "primary",
                            loading: _vm.submitting,
                            icon: "el-icon-refresh",
                          },
                          on: { click: _vm.submit },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.form.runNow
                                  ? "Chuyển đổi dữ liệu"
                                  : "Lưu chờ cronjob"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "sk-dialog__content" }, [
            _c(
              "div",
              { staticClass: "sk-panel" },
              [
                _c("div", { staticClass: "sk-panel-head" }, [
                  _c("div", { staticClass: "sk-panel-icon" }, [
                    _c("i", { staticClass: "el-icon-refresh" }),
                  ]),
                  _c("div", [
                    _c("p", { staticClass: "sk-panel-title" }, [
                      _vm._v("Cấu hình chuyển đổi dữ liệu V4"),
                    ]),
                    _c("p", { staticClass: "sk-panel-subtitle" }, [
                      _vm._v(
                        "\n              Chọn danh sách các trường học, khoảng ngày và loại dữ liệu cần đồng bộ sang V4.\n            "
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      rules: _vm.rules,
                      disabled: _vm.submitting,
                      "label-position": "top",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "sk-form-grid" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Danh sách trường học",
                              prop: "idSchoolList",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "sk-u-w-full",
                                attrs: {
                                  multiple: "",
                                  filterable: "",
                                  "collapse-tags": "",
                                  placeholder: "Chọn trường cần chuyển",
                                },
                                model: {
                                  value: _vm.form.idSchoolList,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "idSchoolList", $$v)
                                  },
                                  expression: "form.idSchoolList",
                                },
                              },
                              _vm._l(_vm.schoolList, function (school) {
                                return _c("el-option", {
                                  key: school.id,
                                  attrs: {
                                    value: school.id,
                                    label:
                                      school.id + " - " + school.schoolName,
                                  },
                                })
                              }),
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "selection-actions" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "action-link",
                                    attrs: { type: "text" },
                                    on: { click: _vm.selectAllSchools },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-check" }),
                                    _vm._v(
                                      " Chọn tất cả " +
                                        _vm._s(_vm.schoolList.length) +
                                        " trường\n                "
                                    ),
                                  ]
                                ),
                                _c("span", { staticClass: "divider" }, [
                                  _vm._v("|"),
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "action-link danger-link",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        _vm.form.idSchoolList = []
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-close" }),
                                    _vm._v(" Bỏ chọn\n                "),
                                  ]
                                ),
                                _c("span", { staticClass: "selected-badge" }, [
                                  _vm._v("\n                  Đã chọn: "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.form.idSchoolList.length)
                                    ),
                                  ]),
                                  _vm._v(" trường\n                "),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Khoảng ngày dữ liệu cần chuyển",
                              prop: "dateRange",
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticClass: "sk-u-w-full",
                              attrs: {
                                type: "daterange",
                                "unlink-panels": "",
                                "range-separator": "-",
                                "start-placeholder": "Từ ngày",
                                "end-placeholder": "Đến ngày",
                                format: "dd/MM/yyyy",
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: _vm.form.dateRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "dateRange", $$v)
                                },
                                expression: "form.dateRange",
                              },
                            }),
                            _c("div", { staticClass: "date-range-hint" }, [
                              _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(
                                " Chỉ nên chuyển tối đa 3 tháng mỗi lần để đảm bảo tốc độ và dễ theo dõi\n              "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "sk-u-mt-12",
                        attrs: { label: "Dữ liệu cần chuyển", prop: "types" },
                      },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            staticClass: "types-checkbox-group",
                            model: {
                              value: _vm.form.types,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "types", $$v)
                              },
                              expression: "form.types",
                            },
                          },
                          _vm._l(_vm.typeOptions, function (type) {
                            return _c(
                              "el-checkbox",
                              {
                                key: type.value,
                                staticClass: "type-checkbox-item",
                                attrs: { label: type.value, border: "" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(type.label) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "sk-u-mt-12",
                        attrs: { label: "Phương thức thực thi" },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.runNow,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "runNow", $$v)
                              },
                              expression: "form.runNow",
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: true, border: "" } },
                              [_vm._v("Chạy ngay")]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { label: false, border: "" } },
                              [_vm._v("Lưu chờ cronjob")]
                            ),
                          ],
                          1
                        ),
                        _c("p", { staticClass: "helper-text" }, [
                          _c("i", { staticClass: "el-icon-info" }),
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.form.runNow
                                  ? "Yêu cầu được đưa vào hàng xử lý sau khi lưu. Nếu hệ thống đang chuyển yêu cầu khác, yêu cầu này sẽ đợi lượt."
                                  : "Yêu cầu được lưu và chỉ chạy khi cronjob kích hoạt. Chưa có lịch chạy được cấu hình cho chức năng này."
                              ) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "sk-panel sk-panel--flat sk-u-mt-12" }, [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c(
                  "div",
                  { staticClass: "sk-panel-icon sk-panel-icon--warning" },
                  [_c("i", { staticClass: "el-icon-warning-outline" })]
                ),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Lưu ý & Quy tắc dữ liệu"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v(
                      "Nguyên tắc cập nhật và ghi nhận dữ liệu khi thực thi"
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "sk-note sk-note--warning" }, [
                _c("i", { staticClass: "el-icon-time" }),
                _c("span", [
                  _c("strong", [_vm._v("Khoảng thời gian:")]),
                  _vm._v(
                    " Chỉ nên chuyển tối đa 3 tháng/lần để đảm bảo tốc độ cập nhật dữ liệu, tối ưu hiệu năng hệ thống, giúp dễ dàng kiểm soát và theo dõi tiến độ."
                  ),
                ]),
              ]),
              _vm.form.types.indexOf("ATTENDANCE") >= 0
                ? _c(
                    "div",
                    { staticClass: "sk-note sk-note--warning sk-u-mt-12" },
                    [
                      _c("i", { staticClass: "el-icon-warning" }),
                      _c("span", [
                        _c("strong", [_vm._v("Điểm danh:")]),
                        _vm._v(
                          " Sẽ cập nhật lại dữ liệu và có thể ghi đè chỉnh sửa đã có trên V4."
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "sk-note sk-u-mt-12" }, [
                _c("i", { staticClass: "el-icon-info" }),
                _c("span", [
                  _c("strong", [_vm._v("Nhận xét:")]),
                  _vm._v(
                    " Nhận xét đã tồn tại được bỏ qua. Nhận xét tuần lấy trọn tuần (từ thứ Hai đến Chủ nhật); nhận xét tháng lấy trọn các tháng trong khoảng đã chọn."
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.jobsVisible,
            title: "Yêu cầu chuyển đổi dữ liệu V4",
            size: "xl",
            top: "3vh",
            "append-to-body": "",
            "close-on-click-modal": false,
            "use-panel": false,
            "dialog-class": "school-migration-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.jobsVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "sk-dialog__footer" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-cancel",
                          attrs: { plain: "" },
                          on: {
                            click: function ($event) {
                              _vm.jobsVisible = false
                            },
                          },
                        },
                        [_vm._v("\n          Đóng\n        ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "sk-dialog__content" }, [
            _c(
              "div",
              { staticClass: "sk-panel" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "sk-panel-head flex items-center justify-between",
                  },
                  [
                    _c("div", { staticClass: "flex items-center gap-3" }, [
                      _c("div", { staticClass: "sk-panel-icon" }, [
                        _c("i", { staticClass: "el-icon-document" }),
                      ]),
                      _c("div", [
                        _c("p", { staticClass: "sk-panel-title" }, [
                          _vm._v("Yêu cầu chuyển đổi đã lưu"),
                        ]),
                        _c("p", { staticClass: "sk-panel-subtitle" }, [
                          _vm._v(
                            "Lịch sử và trạng thái các phiên đồng bộ dữ liệu V4"
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          type: "primary",
                          plain: "",
                          icon: "el-icon-refresh",
                          loading: _vm.refreshing,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.refresh(true)
                          },
                        },
                      },
                      [_vm._v("\n            Tải lại\n          ")]
                    ),
                  ],
                  1
                ),
                _vm.errorText
                  ? _c("div", { staticClass: "sk-note sk-note--danger mb-3" }, [
                      _c("i", { staticClass: "el-icon-error" }),
                      _c("span", [_vm._v(_vm._s(_vm.errorText))]),
                    ])
                  : _vm._e(),
                _c(
                  "el-table",
                  {
                    staticClass: "sk-table",
                    attrs: {
                      data: _vm.jobs,
                      border: "",
                      "highlight-current-row": "",
                      "row-key": (row) => row.jobId,
                    },
                    on: { "row-click": _vm.selectJob },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "STT",
                        type: "index",
                        width: "50",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Ngày tạo",
                        "min-width": "150",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                { staticClass: "font-medium text-slate-700" },
                                [_vm._v(_vm._s(_vm.dateTime(row.createdAt)))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Số trường",
                        width: "105",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                { attrs: { size: "small", type: "info" } },
                                [
                                  _vm._v(
                                    _vm._s(row.idSchoolList.length) + " trường"
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Khoảng dữ liệu",
                        "min-width": "190",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.date(row.fromDate)) +
                                    " – " +
                                    _vm._s(_vm.date(row.toDate))
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Trạng thái",
                        "min-width": "150",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.tagType(row.status),
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.statusLabel(row.status)) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Tiến độ",
                        width: "130",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", { staticClass: "font-medium" }, [
                                _vm._v(
                                  _vm._s(row.completedSteps) +
                                    "/" +
                                    _vm._s(row.totalSteps) +
                                    " bước"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Chi tiết",
                        width: "100",
                        align: "center",
                        fixed: "right",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "sk-table-link",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.selectJob(row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Theo dõi\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm.total > _vm.limit
                  ? _c(
                      "div",
                      { staticClass: "mtr-pagination" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            background: "",
                            "current-page": _vm.page,
                            "page-size": _vm.limit,
                            total: _vm.total,
                            layout: "total, prev, pager, next",
                          },
                          on: { "current-change": _vm.changePage },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.result
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingDetail,
                        expression: "loadingDetail",
                      },
                    ],
                    staticClass: "sk-panel sk-u-mt-12",
                  },
                  [
                    _c("div", { staticClass: "sk-panel-head" }, [
                      _c(
                        "div",
                        { staticClass: "sk-panel-icon sk-panel-icon--success" },
                        [_c("i", { staticClass: "el-icon-data-analysis" })]
                      ),
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("p", { staticClass: "sk-panel-title" }, [
                              _vm._v(
                                "Tiến độ yêu cầu: #" + _vm._s(_vm.result.jobId)
                              ),
                            ]),
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.tagType(_vm.result.status),
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.statusLabel(_vm.result.status)) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("p", { staticClass: "sk-panel-subtitle" }, [
                          _vm._v(
                            "\n              Bắt đầu chạy: " +
                              _vm._s(_vm.dateTime(_vm.result.startedAt)) +
                              " · Kết thúc: " +
                              _vm._s(_vm.dateTime(_vm.result.finishedAt)) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]),
                    _vm.isBusy(_vm.result.status)
                      ? _c("div", { staticClass: "sk-note mb-3" }, [
                          _c("i", { staticClass: "el-icon-info" }),
                          _c("span", [
                            _vm._v(
                              "Tự cập nhật mỗi 5 giây khi mở hộp thoại này. Đóng hộp thoại không làm dừng tác vụ đang chạy ngầm."
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "progress-box mb-4" },
                      [
                        _c("el-progress", {
                          attrs: {
                            percentage: _vm.percent,
                            "stroke-width": 16,
                            status:
                              _vm.result.status === "SUCCEEDED"
                                ? "success"
                                : undefined,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.result.histories && _vm.result.histories.length
                      ? _c(
                          "el-row",
                          {
                            staticClass: "history-grid mb-3",
                            attrs: { gutter: 14 },
                          },
                          _vm._l(_vm.result.histories, function (history) {
                            return _c(
                              "el-col",
                              { key: history.id, attrs: { xs: 24, md: 12 } },
                              [
                                _c("div", { staticClass: "history-card" }, [
                                  _c("div", { staticClass: "history-header" }, [
                                    _c(
                                      "span",
                                      { staticClass: "history-status" },
                                      [_vm._v(_vm._s(history.statusAction))]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "history-time" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dateTime(history.updatedAt)
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "history-description" },
                                    [_vm._v(_vm._s(history.description))]
                                  ),
                                ]),
                              ]
                            )
                          }),
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-table",
                      {
                        staticClass: "sk-table",
                        attrs: {
                          data: _vm.result.schools,
                          border: "",
                          size: "small",
                          "row-key": "idSchool",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "expand" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "expand-table-wrapper p-2 bg-slate-50",
                                      },
                                      [
                                        _c(
                                          "el-table",
                                          {
                                            staticClass: "sk-table",
                                            attrs: {
                                              data: row.steps,
                                              border: "",
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Dữ liệu",
                                                "min-width": "130",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({
                                                      row: step,
                                                    }) {
                                                      return [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.typeLabel(
                                                              step.type
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Khoảng chuyển thực tế",
                                                "min-width": "190",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({
                                                      row: step,
                                                    }) {
                                                      return [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.date(
                                                                step.effectiveFromDate
                                                              )
                                                            ) +
                                                            " – " +
                                                            _vm._s(
                                                              _vm.date(
                                                                step.effectiveToDate
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Trạng thái",
                                                "min-width": "140",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({
                                                      row: step,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "el-tag",
                                                          {
                                                            attrs: {
                                                              type: _vm.tagType(
                                                                step.status
                                                              ),
                                                              size: "mini",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  step.status ===
                                                                    "PENDING" &&
                                                                    _vm.result
                                                                      .status ===
                                                                      "INTERRUPTED"
                                                                    ? "Chưa chạy"
                                                                    : _vm.statusLabel(
                                                                        step.status
                                                                      )
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Đã đọc",
                                                width: "85",
                                                align: "right",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({
                                                      row: step,
                                                    }) {
                                                      return [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              step.sourceCount ||
                                                                (step.countComplete
                                                                  ? 0
                                                                  : "—")
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "successCount",
                                                label: "Thành công",
                                                width: "100",
                                                align: "right",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "skippedCount",
                                                label: "Bỏ qua",
                                                width: "85",
                                                align: "right",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "failedCount",
                                                label: "Lỗi",
                                                width: "75",
                                                align: "right",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "unknownCount",
                                                label: "Chưa xác nhận",
                                                width: "120",
                                                align: "right",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Tiến độ / Lỗi",
                                                "min-width": "220",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({
                                                      row: step,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "step-stage",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(step.stage)
                                                            ),
                                                          ]
                                                        ),
                                                        step.errors &&
                                                        step.errors.length
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "error-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      step.errors.join(
                                                                        "; "
                                                                      )
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2370136057
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "Trường học", "min-width": "220" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-medium text-slate-800",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.schoolLabel(row.idSchool))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3767380257
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Điểm danh",
                            "min-width": "150",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        class: _vm.groupLabelClass(
                                          row.steps.filter(
                                            (step) => step.type === "ATTENDANCE"
                                          )
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.groupLabel(
                                                row.steps.filter(
                                                  (step) =>
                                                    step.type === "ATTENDANCE"
                                                )
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            836223600
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Nhận xét",
                            "min-width": "160",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        class: _vm.groupLabelClass(
                                          row.steps.filter(
                                            (step) => step.type !== "ATTENDANCE"
                                          )
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.groupLabel(
                                                row.steps.filter(
                                                  (step) =>
                                                    step.type !== "ATTENDANCE"
                                                )
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1168834928
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }